import React from "react";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import Context from "../../../Context";
import Blocker from "../../Misc/Blocker";
import SVGShip1 from "../../Misc/SvgIcons/SVGShip1";
import SVGSteering1 from "../../Misc/SvgIcons/SVGSteering1";
import SVGStorage1 from "../../Misc/SvgIcons/SVGStorage1";

const dropRules = {
  manual: {
    reg: /manual/g,
    redirect: "/manual/",
  },
  workdoc: {
    reg: /workdoc/g,
    redirect: "/workdoc/",
  },
  library: {
    reg: /library/g,
    redirect: "/library/",
  },
};

export default class HeaderArea extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      activeItem: {},
      items: {},
      showSelection: false,
    };
  }
  componentDidMount() {
    this.load();
  }
  onSelectionHide = () => {
    this.setState({ showSelection: false });
  };
  onSelectionShow = () => {
    this.setState({ showSelection: true });
  };
  onChange = async (id) => {
    if (id) {
      this.setState({ pending: true });
      let result = await this.context.user.currentSet("area", id);
      if (result) {
        this.reload();
      } else {
        this.context.toast("Не удалось изменить подразделение", "error");
        this.setState({ pending: false });
      }
    }
  };
  reload = () => {
    let url = new URL(document.location);
    let redirectUrl = false;
    Object.entries(dropRules).forEach(([key, rule]) => {
      if (rule.reg.test(url.pathname)) {
        redirectUrl = rule.redirect;
      }
    });
    if (redirectUrl) {
      document.location.href = redirectUrl;
    } else {
      document.location.reload();
    }
  };
  load = async () => {
    this.setState({ pending: true });
    let items = await this.context.api.qoo("/member/area");
    let activeItem = await this.context.user.currentGet("area");
    this.setState({ pending: false, items, activeItem });
  };
  render() {
    if (this.state.pending) {
      return <span className="spinner"></span>;
    }

    const levelMargins = {
      0: "ml-0",
      1: "ml-3",
      2: "ml-6",
      3: "ml-8",
      4: "ml-10",
      5: "ml-10",
      6: "ml-12",
    };

    const typeIcons = {
      mobile: <SVGShip1 />,
      main: <SVGStorage1 />,
    };

    const { activeItem } = this.state;

    return (
      <>
        <div
          className="mr-2 d-flex align-items-center"
          title="Текущее подразделение"
        >
          {activeItem.typecode === "mobile" && (
            <span className="svg-icon svg-icon-md svg-icon-primary mr-2">
              <Link to="/ship/">{typeIcons[activeItem.typecode]}</Link>
            </span>
          )}
          <span
            className="text-hover-primary cursor-pointer"
            onClick={this.onSelectionShow}
          >
            {activeItem.name}
          </span>
        </div>
        <Modal show={this.state.showSelection} onHide={this.onSelectionHide}>
          <Modal.Header closeButton>
            <Modal.Title className="w-100">Выберите подразделение</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Blocker on={this.state.pending}>
              {Object.entries(this.state.items).map(([id, item]) => {
                let margin = levelMargins[item.level];
                if (item.typecode === "root") return null;
                return (
                  <div
                    key={id}
                    onClick={() => this.onChange(item.id)}
                    className={`px-3 py-2 bg-hover-light cursor-pointer ${
                      activeItem.id === item.id ? "bg-light" : ""
                    }`}
                  >
                    <div
                      className={`${margin} d-flex justify-content-between align-items-center`}
                    >
                      <div>
                        <div>{item.name}</div>
                        <div className="small text-dark-50">
                          {item.description}
                        </div>
                      </div>
                      <div>
                        <span
                          className={`svg-icon svg-icon-${
                            activeItem.id === item.id ? "primary" : "muted"
                          } svg-icon-2x ml-n1`}
                        >
                          {typeIcons[item.typecode]}
                        </span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </Blocker>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}
